module.exports = __webpack_public_path__ + "static/img/banner_img2.9c34130.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_img2.png
// module id = pz1z
// module chunks = 4